<template>
	<div tabindex="-1" ref="rootTag" class="no-focus-visible-outline">

		<HeaderControls :myWeek='false' :parentDeliverableId="parentDeliverableId" @filterUpdated='filterUpdate'
			@collapseToggleUpdated='collapseToggleUpdate' @showEditDeliverableModal="showEditDeliverableModal"
			:namespace="namespace" :tabTitle="tabTitle" :pageCount="pageCount" :showCreatedPostedDateSort="isListAllView"
			ref="refHeaderControls" />

		<div class="deliverable-main container-fluid">
			<div class="deliverable-listing social-media-grouped"
				:class="{ hasFilter: (planFilterQuery.status.length || planFilterQuery.coordinator.length || planFilterQuery.tag.length || planFilterQuery.outlet.length) }">


				<b-modal centered no-close-on-backdrop hide-footer id="viewTitleModal" title="Enter View Title">
					<ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal" />
				</b-modal>
				<b-modal centered no-close-on-backdrop hide-footer id="viewTitleUpdateModal" title="Enter View Title">
					<ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView"
						ref="refViewTitleModal" />
				</b-modal>

				<b-modal no-close-on-backdrop id="deleteRelatedDeliverableConfirmModal" type="warn" title="Confirm Deletion"
					@ok="onConfirmRemoveDeliverable" @cancel="onCancelRemoveDeliverable" ok-title="Yes, Delete">
					<p>Are you sure you want to delete <strong v-if="showRemoveDeliverable"
							v-html="showRemoveDeliverable.title"></strong>?</p>
				</b-modal>

				<b-modal size="lg" no-close-on-backdrop hide-footer id="editSocialCampaignModal"
					title="Edit Social Campaign" class="modal-edit-social-campaign">
					<SocialCampaignDialog ref="refSocialCampaignDialogModal" @socialCampaignClose="createCampaignClose"
						:namespace="namespace" />
				</b-modal>
				<div class="related-deliverable-block-wrap">
					<HorizontalMonthPicker :namespace="namespace" :parentDeliverableId="parentDeliverableId" />
					<div class="deliverable-group-views-wrapper" v-if="false">
						<span class="d-inline-block float-right saved-views-area"
							:class="[!showUpdateViewText ? 'pt-15' : '', activeView != '-1' ? 'saved-view-active' : '']">


							<div class="text-right" v-show="showUpdateViewText">
								<a href="#" @click="directUpdateView">Click here</a> to save updated view
							</div>
							<div class="btn-group float-right add-new__global_search sorting saved-views">
								<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle" type="button"
									data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
									@click="updatePerfectScroll" v-if="!showCreateNewView">
									<span class="updated-view" v-if="showUpdateViewText"></span>
									<span class="mr-3 view__label truncate-text">{{ viewBtnLabel }}</span>
									<i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
									<i v-else v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Clear View"
										@click.stop="handleResetFilter()"
										class="fas fa-fw fa-eye text-primary float-right"></i>
								</button>
								<button class="btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view"
									type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-else>
									<span class="updated-view" v-if="showUpdateViewText"></span>
									<span class="mr-3 view__label">Views</span>
									<i v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Save View"
										@click.stop="saveView" class="fas fa-fw fa-eye text-primary float-right"></i>
								</button>
								<div class="dropdown-menu viewmenu-dropdown">
									<div>
										<a class="dropdown-item update-view" @click="updateView" href="#">
											Update View
											<span class="float-right">
												<i class="far fa-edit text-primary"></i>
											</span>
										</a>
										<a class="dropdown-item save-view" @click="saveView" href="#">
											Save View
											<span class="float-right">
												<i class="fas fa-plus-circle text-primary"></i>
											</span>
										</a>
										<perfect-scrollbar class="views__scroll" ref="views__scroll">
											<div>
												<!-- Preset Views (Hardcode) -->
												<a class="dropdown-item" :class="{ active: activeView == userView.id }"
													@click="loadView(userView, index)"
													:key="'userView' + index + 1 * Math.random()"
													v-for="(userView, index) in presetViewsDashboard" href="#">
													<div class="preset-icon-wrap">
													</div>
													<span class="save-title">{{ userView.title }}</span>
												</a>

												<!-- User Views -->
												<a class="dropdown-item" :class="{ active: activeView == userView.id }"
													@click="loadView(userView, index)"
													:key="'userView' + index + 1 * Math.random()"
													v-for="(userView, index) in userViewsDeliverable" href="#">
													<div class="remove-icon-wrap">
														<span class="remove-icon" @click.stop="removeView(userView.id)">
															<i class="fas fa-trash"></i>
														</span>
													</div>
													<span class="save-title">{{ userView.title }}</span>
												</a>
											</div>
										</perfect-scrollbar>
									</div>
								</div>
							</div>
						</span>
						<!-- Expand / Collapse all button from the header -->
						<span class="d-inline-block float-right pt-15 mr-3 expand-all-area" v-if="false">
							<div v-if="$router.currentRoute.name != 'globalSearch' && $router.currentRoute.name != 'calendar'"
								class="ml-2 expand-grp cursor-pointer" @click="toggleExpandAll(!expandAll)">
								<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': expandAll }"
									variant="theme" v-b-tooltip.hover title="Expand">
									<span class="text">Expand All </span>
									<span class="icon"><i class="fas text-primary fa-expand fa-fw"></i></span>
								</b-button>
								<b-button class="header-filter-btns expand-ctrls" :class="{ 'none-active-btn': !expandAll }"
									variant="theme" v-b-tooltip.hover title="Collapse">
									<span class="text">Collapse All</span>
									<span class="icon"><i class="fas text-primary fa-compress fa-fw"></i></span>
								</b-button>
							</div>
						</span>

						<div class="d-inline-block float-right saved-views-area pt-15" v-if="false">
							<div class="text-right">
								<div class="group-by-wrap dropdown">
									<button type="button" class="btn btn-theme header-filter-btns"
										data-toggle="dropdown">List by <i
											class="fas text-primary float-right fa-chevron-down fa-fw"></i></button>
									<div class="dropdown-menu">
										<router-link class="dropdown-item"
											:to="{ name: 'socialMedia', params: { socialGroupBy: 'socialMedia' } }">Dates</router-link>
										<router-link class="dropdown-item"
											:to="{ name: 'socialMediaGrouped', params: { socialGroupBy: 'socialMediaGrouped' } }">Campaign/Series</router-link>
									</div>
								</div>
							</div>
						</div>

						<div class="d-inline-block float-right saved-views-area pt-15 mr-2" v-if="false">
							<div class="new-social-group-container dropdown">
								<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">New <i
										class="fas text-primary float-right fa-plus fa-fw"></i></button>
								<div class="dropdown-menu">
									<a class="dropdown-item" href="#" @click="createCampaignClick">Campaign</a>
									<a class="dropdown-item" href="#" @click="createSeriesClick">Series</a>
								</div>
							</div>
						</div>

					</div><!-- End of views wrapper -->

					<!-- All View -->
					<template v-if="isListAllView && parentDeliverableId">
						<SocialMediaListAll :selectedDeliverable="selectedDeliverable" :listView="true"
							:calendarOnly="false" :hasSocialCampaign="false" :hasSocialSeries="false"
							:socialCampaignId="null" :socialSeriesId="null" :filterQuery="planFilterQuery" :myWeek="false"
							:expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'
							:parentDeliverableId="parentDeliverableId" :namespace="namespace"
							@showEditDeliverableModal="showEditDeliverableModal"
							@deleteSocialMediaDeliverable="deleteDeliverableClick" showNewPostButton="true"
							:pageCount="pageCount" @duplicateDeliverable="duplicateDeliverable" />
					</template>

					<!-- List view -->
					<template v-if="isListView && parentDeliverableId">
						<SocialMediaByDate :selectedDeliverable="selectedDeliverable" :listView="true" :calendarOnly="false"
							:hasSocialCampaign="false" :hasSocialSeries="false" :socialCampaignId="null"
							:socialSeriesId="null" :filterQuery="planFilterQuery" :myWeek="false" :expandAll="expandAll"
							@collapseToggleUpdated='collapseToggleUpdate' :parentDeliverableId="parentDeliverableId"
							:namespace="namespace" @showEditDeliverableModal="showEditDeliverableModal"
							@deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" showNewPostButton="true" />
					</template>

					<!-- Grouped view -->
					<template v-if="!isListView && !isListAllView && parentDeliverableId">
						<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="true"
							:hasSocialCampaign="false" :hasSocialSeries="false" :socialCampaignId="null"
							:socialSeriesId="null" :filterQuery="planFilterQuery" :myWeek="false" :expandAll="expandAll"
							:parentDeliverableId="parentDeliverableId" @collapseToggleUpdated='collapseToggleUpdate'
							@showEditDeliverableModal="showEditDeliverableModal"
							@deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" showNewPostButton="true"
							:namespace="namespace" />

						<!-- campaigns, campaigns with series -->
						<div v-for="(campaign, campaign_idx) in listSocialCampaigns" :key="'campaign' + campaign_idx">

							<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false"
								:hasSocialCampaign="true" :hasSocialSeries="false" :socialCampaignId="campaign.id"
								:socialCampaignName="campaign.title" :socialSeriesId="null" :socialSeriesName="null"
								:filterQuery="planFilterQuery" :myWeek="false" :expandAll="expandAll"
								@collapseToggleUpdated='collapseToggleUpdate'
								@showEditDeliverableModal="showEditDeliverableModal"
								@deleteSocialMediaDeliverable="deleteSocialMediaDeliverable"
								:listCount="campaign.list_count" :totalCount="campaign.total_count" showNewPostButton="true"
								:namespace="namespace" />

							<div v-for="(series, series_idx) in getListSocialSeriesWithSocialCampaign(campaign.id)"
								v-if="series_idx != 'totalOutlets'" :key="'campaignseries' + series_idx">
								<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false"
									:hasSocialCampaign="true" :hasSocialSeries="true" :socialCampaignId="campaign.id"
									:socialCampaignName="campaign.title" :socialSeriesId="series.id"
									:masterDeliverableId="series.master_deliverable_id" :socialSeriesName="series.title"
									:filterQuery="planFilterQuery" :myWeek="false" :expandAll="expandAll"
									@collapseToggleUpdated='collapseToggleUpdate'
									@showEditDeliverableModal="showEditDeliverableModal"
									@deleteSocialMediaDeliverable="deleteSocialMediaDeliverable"
									:listCount="series.list_count" :totalCount="series.total_count" showNewPostButton="true"
									:namespace="namespace" />
							</div>
						</div>


						<div v-for="(series, series_index) in getListSocialSeriesWithoutSocialCampaign()"
							:key="'seriesAlone-' + series_index">
							<SocialGrouped :selectedDeliverable="selectedDeliverable" :calendarOnly="false"
								:hasSocialCampaign="false" :hasSocialSeries="true" :socialCampaignId="null"
								:socialSeriesId="series.id" :socialSeriesName="series.title"
								:masterDeliverableId="series.master_deliverable_id" :filterQuery="planFilterQuery"
								:myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate'
								@showEditDeliverableModal="showEditDeliverableModal"
								@deleteSocialMediaDeliverable="deleteSocialMediaDeliverable" :listCount="series.list_count"
								:totalCount="series.total_count" :namespace="namespace" showNewPostButton="true" />
						</div>
					</template>

				</div>

			</div>
		</div>

	</div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import HeaderControls from "../common/HeaderControlsRelatedDeliverablesSocial";
import HorizontalMonthPicker from '../common/HorizontalMonthPicker';
import ViewTitleModal from "../common/ViewTitleModal";
import EditSocialModal from "./EditSocialModal";
import SocialCampaignDialog from "./SocialCampaignDialog.vue";
import SocialGrouped from "./SocialGrouped";
import SocialMediaByDate from "./SocialMediaByDate";
import SocialMediaListAll from "./SocialMediaListAll";


export default {
	data() {
		return {
			pageCount: 10,
			showRemoveDeliverableId: null,
			showRemoveDeliverable: { title: "this deliverable" },
			planFilterQuery: {
				page: 1,
				query: "",
				groupSeriesPosts:true,
				filterByDate: false,
				filterByDateCreated: false,
				filterByDateCompleted: false,
				listByPublishDate: false,
				listByDate: true,
				listByDateField: "title",
				listByDateRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				dateRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				dateCreatedRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				dateCompletedRange: {
					startDate: new Date(),
					endDate: new Date()
				},
				status: [],
				outlet: [],
				deliverableType: [],
				tag: [],
				department: [],
				coordinator: [],
				project: [],
				parentDeliverableId: 0,
			},
			expandAll: !this.isMobile(),
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,
			isCreateCampaignOpen: false,
			isListAllView: false,
			isListView: false,
			selectedDeliverable: false,
			windowScrollTop: 0,
			tabIndex: 0,
		}
	},
	props: {
		parentDeliverableId: Number,
		namespace: String,
		tabTitle: String,
	},
	created() {
		this.fetchSystemSettings();
		this.fetchSocialSeries();
		this.fetchSocialCampaigns();
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
		this.isListView = false;
		this.isListAllView = true;
	},
	computed: {
		...mapState({
			state(state) {
				return state[this.namespace];
			},
			allContacts(state, getters) {
				return getters[this.namespace + 'allContacts']
			},
			allCustomFields(state, getters) {
				return getters[this.namespace + 'allCustomFields']
			},
			allUsers(state, getters) {
				return getters['allUsers']
			},
			allDeliverablesPaginationData(state, getters) {
				return getters[this.namespace + 'allDeliverablesPaginationData']
			},
			outletCount(state, getters) {
				return getters[this.namespace + 'outletCount']
			},
			getSocialMediaOnlyCalendar(state, getters) {
				return getters[this.namespace + 'getSocialMediaOnlyCalendar']
			},
			getSocialMediaWithSocialCampaign(state, getters) {
				return getters[this.namespace + 'getSocialMediaWithSocialCampaign']
			},
			getListSocialSeriesWithSocialCampaign(state, getters) {
				return getters[this.namespace + 'getListSocialSeriesWithSocialCampaign']
			},
			listSocialCampaigns(state, getters) {
				return getters[this.namespace + 'listSocialCampaigns']
			},
			listSocialSeries(state, getters) {
				return getters[this.namespace + 'listSocialSeries']
			},
			socialCampaigns(state, getters) {
				return getters[this.namespace + 'socialCampaigns']
			},
			socialSeries(state, getters) {
				return getters[this.namespace + 'socialSeries']
			},
			userViews(state, getters) {
				return getters[this.namespace + 'userViews']
			},
			getListSocialSeriesWithoutSocialCampaign(state, getters) {
				return getters[this.namespace + 'getListSocialSeriesWithoutSocialCampaign']
			},
			deliverableDetail(state, getters) {
				return getters[this.namespace + 'deliverableDetail']
			},
			socialMediaFilter(state, getters) {
				return getters[this.namespace + 'socialMediaFilter']
			},


			editSocialModal(state, getters) {
				return getters[this.namespace + "editSocialModal"];
			},
			addContactModal(state, getters) {
				return getters[this.namespace + "addContactModal"];
			},
			editContactModal(state, getters) {
				return getters[this.namespace + "editContactModal"];
			},
			editSpokespersonModal(state, getters) {
				return getters[this.namespace + "editSpokespersonModal"];
			},
			editWhoModal(state, getters) {
				return getters[this.namespace + "editWhoModal"];
			},
			getDeliverableTemplateSlug(state, getters) {
				return getters[this.namespace + "getDeliverableTemplateSlug"];
			},

		}),

		statuses() {
			let statusField = _.find(this.allCustomFields,
				{ field_key: "status" });
			if (typeof statusField != "undefined") {
				let valueSet = [],
					data = JSON.parse(statusField.value_set);
				Object.keys(data).forEach(function (item) {
					valueSet.push(data[item]);
				});
				return valueSet;
			}
		},

		// Hardcode
		presetViewsMyWeek() {
			return [
				{
					id: 'p01',
					createdTime: null,
					title: "Default",
					saved_data: `{"query":"","sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"filterByPublishDate":false,"dateRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCreatedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCompletedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"datePublishRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"status":[],"publishStatus":[],"socialNetwork":[],"socialSeries":[],"socialCampaign":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","weekFilterOptions":{"overdue":false,"today":false,"thisWeek":false,"nextWeek":false,"upcoming":false,"noDeadline":false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p1',
					createdTime: null,
					title: "Today",
					saved_data: `{"query":"","sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"filterByPublishDate":true,"dateRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCreatedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"dateCompletedRange":{"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"},"datePublishRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"status":[],"publishStatus":[],"socialNetwork":[],"socialSeries":[],"socialCampaign":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","weekFilterOptions":{"overdue":false,"today":false,"thisWeek":false,"nextWeek":false,"upcoming":false,"noDeadline":false}}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p2',
					createdTime: null,
					title: "This Week",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().startOf('week').toISOString()}", "endDate": "${this.$moment().endOf('week').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false } }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p3',
					createdTime: null,
					title: "Next Week",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().add(1, 'week').startOf('week').toISOString()}", "endDate": "${this.$moment().add(1, 'week').endOf('week').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},

				{
					id: 'p5',
					createdTime: null,
					title: "This Month",
					saved_data: `{"query": "", "sort": "", "priorityFilter": 0, "outletCompany": [], "filterByDate": false, "filterByDateCreated": false, "filterByDateCompleted": false, "filterByPublishDate": true, "dateRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCreatedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "dateCompletedRange": {"startDate": "2022-03-02T17:35:59.190Z","endDate": "2022-03-02T17:35:59.190Z"}, "datePublishRange": {"startDate": "${this.$moment().startOf('month').toISOString()}", "endDate": "${this.$moment().endOf('month').toISOString()}"}, "status": [], "publishStatus": [], "socialNetwork": [], "socialSeries": [], "socialCampaign": [], "outlet": [], "deliverableType": [], "tag": [], "department": [], "coordinator": [], "project": [], "noDeparment": "not_accepted", "noOutlet": "not_accepted", "weekFilterOptions": {"overdue": false, "today": false, "thisWeek": false, "nextWeek": false, "upcoming": false, "noDeadline": false} }`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]
		},
		presetViewsDashboard() {
			const filterForMyWeek = this.presetViewsMyWeek;
			const filterForDashboard =
				[
				]

			return filterForDashboard.concat(filterForMyWeek);
		},
		userViewsDeliverable() {
			return _.filter(this.userViews, { view_type: "socialMedia" });
		},

		deliverableTotalMinusMasters() {
			if (this.allDeliverablesPaginationData.total == undefined) {
				return 0;
			}
			let total = this.allDeliverablesPaginationData.total;
			let masters = this.allDeliverablesPaginationData.data.filter(function (deliverable) {
				return deliverable.is_master;
			});
			let result = total - masters.length;
			return result;
		}
	},

	components: {
		SocialGrouped,
		SocialMediaByDate,
		SocialMediaListAll,
		HeaderControls,
		HorizontalMonthPicker,
		EditSocialModal,
		SocialCampaignDialog,
		ViewTitleModal,
	},

	methods: {
		...mapActions({
			fetchSystemSettings(dispatch, payload) {
				return dispatch(this.namespace + "fetchSystemSettings")
			},
			fetchDeliverables(dispatch, payload) {
				return dispatch(this.namespace + "fetchDeliverables")
			},
			createTag(dispatch, payload) {
				return dispatch(this.namespace + "createTag")
			},
			fetchUsers(dispatch, payload) {
				return dispatch(this.namespace + "fetchUsers")
			},
			fetchSocialSeries(dispatch, payload) {
				return dispatch(this.namespace + "fetchSocialSeries")
			},
			fetchSocialCampaigns(dispatch, payload) {
				return dispatch(this.namespace + "fetchSocialCampaigns")
			},
			fetchActiveUsers(dispatch, payload) {
				return dispatch(this.namespace + "fetchActiveUsers")
			},
			fetchContacts(dispatch, payload) {
				return dispatch(this.namespace + "fetchContacts")
			},
			updateFieldValue(dispatch, payload) {
				return dispatch(this.namespace + "updateFieldValue")
			},
			fetchDepartments(dispatch, payload) {
				return dispatch(this.namespace + "fetchDepartments")
			},
			fetchActiveDepartments(dispatch, payload) {
				return dispatch(this.namespace + "fetchActiveDepartments")
			},
			fetchSubjects(dispatch, payload) {
				return dispatch(this.namespace + "fetchSubjects")
			},
			fetchTags(dispatch, payload) {
				return dispatch(this.namespace + "fetchTags")
			},
			fetchGeoData(dispatch, payload) {
				return dispatch(this.namespace + "fetchGeoData")
			},
			fetchAllCustomFields(dispatch, payload) {
				return dispatch(this.namespace + "fetchAllCustomFields")
			},
			filterDeliverables(dispatch, payload) {
				return dispatch(this.namespace + "filterDeliverables")
			},
			fetchViews(dispatch, payload) {
				return dispatch(this.namespace + "fetchViews")
			},
			fetchProjects(dispatch, payload) {
				return dispatch(this.namespace + "fetchProjects")
			},
			getDeliverableTypes(dispatch, payload) {
				return dispatch(this.namespace + "getDeliverableTypes")
			},
			fetchUserManageProjects(dispatch, payload) {
				return dispatch(this.namespace + "fetchUserManageProjects")
			},
			fetchDeliverableCount(dispatch, payload) {
				return dispatch(this.namespace + "fetchDeliverableCount")
			},
			updateSocialMediaPostUrl(dispatch, payload) {
				return dispatch(this.namespace + "updateSocialMediaPostUrl")
			},
			createSocialCampaign(dispatch, payload) {
				return dispatch(this.namespace + "createSocialCampaign")
			},
			createSocialSeries(dispatch, payload) {
				return dispatch(this.namespace + "createSocialSeries")
			},
			fetchSocialMediaDeliverablesGrouped(dispatch, payload) {
				return dispatch(this.namespace + "fetchSocialMediaDeliverablesGrouped")
			},
		}),
		...mapMutations({
			setDataLoading(commit, payload) {
				return commit(this.namespace + 'setDataLoading', payload)
			},
		}),
		filterUpdate(planFilterQuery) {
			this.planFilterQuery = planFilterQuery
		},
		collapseToggleUpdate(expandAll) {
			this.expandAll = expandAll
		},
		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit('resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function () {
				if (typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if (localStorage.getItem('socialMediaActiveSave')) {
				this.activeView = localStorage.getItem('socialMediaActiveSave');
				this.viewBtnLabel = localStorage.getItem('socialMediaActiveSaveTitle');
				this.currentViewData = localStorage.getItem('socialMediaActiveSaveData');
				if (!this.activeView.startsWith('p')) this.showUpdateView = true;
			} else {
				this.activeView = '-1';
				this.viewBtnLabel = 'Views';
				this.showUpdateViewText = false;
			}
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		removeView(viewId) {
			if (viewId == localStorage.getItem('socialMediaActiveSave')) {
				this.resetView();
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("socialMediaActiveSave");
			localStorage.removeItem("socialMediaActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			this.activeView = index;
			localStorage.setItem('socialMediaActiveSave', index);
			localStorage.setItem('socialMediaActiveSaveTitle', viewData.title);
			localStorage.setItem('socialMediaActiveSaveData', viewData.saved_data);
			this.$store.commit(this.namespace + "setSocialMediaFilter", this.currentViewData);
			this.$root.$emit('setSaveView', this.socialMediaFilter);
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			view = this.socialMediaFilter;
			let viewData = {
				title: this.viewBtnLabel,
				planFilterQuery: view,
				viewId: this.activeView
			};
			let that = this;
			this.$store.dispatch("saveView", viewData).then(function () {
				localStorage.setItem('socialMediaActiveSaveData', JSON.stringify(view));
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		showEditDeliverableModal(deliverable, tab) {
			let that=this;
			this.windowScrollTop = $(window).scrollTop();
			let deliverableId = null;
			if (typeof deliverable === "object") {
				deliverableId = deliverable.id;
				this.selectedDeliverable = deliverable.id;
				if (deliverable.social_series.length && !deliverable.manually_updated_at) {
					deliverableId = this.getSeriesMasterByDeliverable(deliverable);
				}
			} else {
				deliverableId = deliverable;
				this.selectedDeliverable = deliverableId;
			}
			if (tab === null || tab === undefined) {
				tab = 0;
			}


			this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {

					if (this.$refs.refEditRelatedSocialModal) {
						// already open
					} else {
						this.pushRoute();
						that.tabIndex = tab;

						//  this.$bvModal.hide("editSocialModal");
						that.$bvModal.show("editRelatedSocialModal", {
							backdrop: 'static',
							keyboard: true,
						});
					}

				});

			this.$root.$emit('bv::modal::disable-pointer-events');

		},

		pushRoute() {
			return;
			if (this.isListView) {
				history.pushState(
					{},
					null,
					'/social-media/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			} else {
				history.pushState(
					{},
					null,
					'/social-media-grouped/' + encodeURIComponent(this.deliverableDetail.id) + (this.deliverableDetail.slug ? ('/' + encodeURIComponent(this.deliverableDetail.slug) + '/') : '')
				)
			}
			let currentTitle = document.title.match(/\(\d+\)\s/g);
			if (!currentTitle) {
				document.title = this.deliverableDetail.title;
			} else {
				document.title = currentTitle[0] + this.deliverableDetail.title;
			}
		},

		/*
		removeRoute() {
			history.pushState(
				{},
				null,
				this.$router.currentRoute.matched[0].path
			);
		},
		*/

		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

		// Status toggle from the header
		toggleExpandAll(expandAll) {
			this.$emit("collapseToggleUpdated", expandAll);
		},

		calculateEndDate(deliverable) {
			let latestDueDate = null;

			let end_date = _.filter(deliverable.customFields, { field_key: 'end_date' });
			if (end_date.length > 0) {
				return end_date[0].value;
			}
			let end_datetime = _.filter(deliverable.customFields, { field_key: 'end_datetime' });
			if (end_datetime.length > 0) {
				return end_datetime[0].value;
			}
			let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
			if (publish_datetime.length > 0) {
				return publish_datetime[0].value;
			}

			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},

		closeVuewSelectModal() {
			this.$bvModal.hide("headerViewSelectModal");
		},

		userCanEditDeliverable() {
			return (this.userAbilities.deleteMediaCall);
		},

		duplicateDeliverable(deliverable) {
			let that = this;
			let slug = "";
			slug = this.getDeliverableTemplateSlug(deliverable.deliverable_template_id);

			if (slug == "social-media") {
				let that = this;
				this.$store.dispatch(this.namespace + 'duplicateSocialMedia', { deliverableId: deliverable.id }).then(function () {
					// TODO: determine if we need to call fetch social media deliverables grouped.
					that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped', { filter: that.socialMediaFilter, page: that.socialMediaFilter.page, pageCount: that.socialMediaFilter.pageCount }).then(function () {
						that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function () {
							that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
						});
					});
					that.showEditDeliverableModal(that.deliverableDetail, 0);

					// TODO: re-open social media modal after duplicating?
					window.scrollTo(0, 0);
				});
			}
		},

		deleteSocialMediaDeliverable(deliverable) {
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.$bvModal.show("deleteRelatedDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteRelatedDeliverableConfirmModal");
				}
			}
		},
		deleteDeliverableClick(deliverable) {
			console.log("deleteDeliverableClick", deliverable);
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.showRemoveDeliverable = deliverable;
				this.$bvModal.show("deleteRelatedDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteRelatedDeliverableConfirmModal");
				}
			}
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},
		onConfirmRemoveDeliverable() {
			let that = this;

			if (this.showRemoveDeliverableId) {
				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId: this.showRemoveDeliverableId }).then(function () {
					that.$bvModal.hide("deleteRelatedDeliverableConfirmModal");
					that.$bvModal.hide("editSocialModal");
					that.showRemoveDeliverableId = null;
					that.$store.dispatch(that.namespace + 'fetchSocialMediaDeliverablesGrouped', { filter: that.socialMediaFilter, page: that.socialMediaFilter.page, pageCount: that.socialMediaFilter.pageCount }).then(function () {
						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');
					});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		createCampaignClick() {
			let that = this;

			this.createSocialCampaign({
				title: "Social Campaign"
			}).then(() => {
				this.$nextTick(() => {
					that.$bvModal.show('editSocialCampaignModal');
				});
			});
		},
		calculateCampaignDialogSpace() {
			let target = $(".new-social-group-container");
			const offset = target.offset();
			const dh = $("html").height();

			this.$nextTick(() => {
				const dialog = target.find(".social-media-group-popup");
				const dialogHeight = dialog.height();

				if ((offset.top + 100 + dialogHeight) > dh) {
					// Option 2: Put the dialog on top of the title
					dialog.addClass("is-top");
				}
			});
		},
		createCampaignClose() {
			this.isCreateCampaignOpen = false;
		},
		createSeriesClick() {
			let that = this;

			this.createSocialSeries().then(() => {
				that.$bvModal.show('editSocialModal');
			});
		},
		getSeriesMasterByDeliverable(deliverable) {
			if (typeof deliverable.social_series_deliverables != "undefined") {
				let series = deliverable.social_series_deliverables;
				if (series.length) {
					let master = series.find(x => x.is_master === 1);
					if (master) {
						return master.id;
					}
				}
			}
			return false;
		},

	},
	beforeUpdate() {
		if (this.activeView != '-1' && ((typeof this.activeView).toLowerCase() == "string" ? !this.activeView.startsWith('p') : true)) {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if (!$('.deliverable-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');

			if (this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if ($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}

		this.viewModalShowCreateView = !$('.save-view').hasClass('d-none');
		this.viewModalShowUpdateView = !$('.update-view').hasClass('d-none');
	},
	mounted() {
		document.body.classList.add("related-social-media");
		let that = this;
		this.$nextTick(function () {
			setTimeout(function () {
				that.$refs.rootTag.focus();
			}, 200);
		});

	},
	watch: {
		'parentDeliverableId': function (oldVal, newVal) {
			this.$set(this.planFilterQuery, 'parentDeliverableId', newVal);
			this.$set(this.planFilterQuery, 'pageCount', this.pageCount);
			this.$set(this.planFilterQuery, 'page', 1);
			this.isListAllView = true;
			this.isListView = false;
			this.fetchSocialMediaDeliverablesGrouped({ filter: this.planFilterQuery });
		},
	}
}
</script>
